import { browserDefaultLineHeight } from 'client/constants/editorSettings'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { useWebsiteSettings } from 'client/store'
import { getWebsiteStylesTypographyParagraph } from 'src/editor/store/website-settings/website-settings-selector'

export const useHeadingLineHeight = ({
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
}: {
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
}) => {
  const { isMobile } = useDeviceModeContext()
  const {
    fontSize: globalFontSize,
    mobileFontSize: globalMobileFontSize,
    lineHeight: globalLineHeight,
    mobileLineHeight: globalMobileLineHeight,
  } = useWebsiteSettings(getWebsiteStylesTypographyParagraph) || {}

  const currentLineHeight = isMobile
    ? mobileLineHeight || globalMobileLineHeight
    : lineHeight || globalLineHeight
  const currentFontSize = isMobile
    ? mobileFontSize || globalMobileFontSize
    : fontSize || globalFontSize

  const calculatedFontSize = currentFontSize as number
  const computedLineHeight = Math.round(
    browserDefaultLineHeight * calculatedFontSize,
  )

  const calculatedLineHeight = currentLineHeight || computedLineHeight

  return {
    calculatedLineHeight,
    globalLineHeight,
    globalMobileLineHeight,
  }
}
